'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const collections = require('./model/model.collections').collections;
const buttonConstants = require('./utils/button.constants');

module.exports = createWidgetFactory({
    name: 'payment_button',
    viewClass: require('./view'),
    modelClass: require('./model'),
    methods: {
        load(callback = () => {}) {
            this.load(callback);
        },
        forceLoad() {
            collections.insurances.forceLoad();
            collections.serviceOptions.forceLoad();
            this.load();
        },
        getCheckDoCheckout() {
            return this.getCheckDoCheckout();
        },
        forceRender() {
            this.load();
        },
        removeProductFromShoppingCartIfNeeded(data = {}) {
            this.model.removeProductFromShoppingCartIfNeeded({...data, model: this.model});
        },
        storeProductSelection(data = {}, callback = () => {}) {
            this.model.storeProductSelection(data);
            this.load(callback);
        },
        togglePaymentBtn(disabled) {
            this.toggleContinueButtons(buttonConstants.SINGLE, disabled);
        },
        toggleButtons(disabled) {
            this.toggleButtons(disabled);
        },
        setRepricing(data) {
            this.model.setRepricing(data);
            this.load();
        },
        getExpectedPrice(callback = () => {}) {
            callback(this.getExpectedPrice());
        },
        isPWGButton() {
            return buttonConstants.PAY_WITH_GUARANTEE === this.getLastPressedButton();
        },
        checkMustHideTotalPrice(callback = () => {}) {
            callback(this.getLoadCallbackData().mustHideTotalPrice);
        },
        storeTotalTicketPrice(price) {
            this.model.storeTotalTicketPrice(price);
            this.load();
        },
    },
});
